import LanguageHandler from "@payair/e-com-common-sdk/core/LanguageHandler"
import { ConsumerInfoFormError } from "../components/consumerInfoForm/ConsumerInfoFormValidity.model"

const translate = (languageHandler: LanguageHandler, key: string): string =>
  languageHandler.getString(key) || languageHandler.getString("wrongFormat") || ""

export const getConsumerInfoValidationMessage = (
  languageHandler: LanguageHandler,
  error: ConsumerInfoFormError
): string => {
  if (error.code === "REQUIRED") {
    return translate(languageHandler, "requiredField")
  }

  if (error.code === "INVALID_FORMAT") {
    if (error.field === "firstName" || error.field === "lastName") {
      return translate(languageHandler, "nameWrongFormat")
    }

    return translate(languageHandler, "wrongFormat")
  }

  if (error.minLength !== undefined && error.maxLength !== undefined) {
    return translate(languageHandler, "allowedLengthRange")
      .replace("{min}", error.minLength.toString())
      .replace("{max}", error.maxLength.toString())
  }

  if (error.maxLength !== undefined) {
    return translate(languageHandler, "maximumLength").replace("{max}", error.maxLength.toString())
  }

  return translate(languageHandler, "invalidLength")
}
